var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.resourcesNumber)+" resources • "+_vm._s(_vm.humanTime)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }